/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Extract_Container_LabelInputs */



/**
* | output |
* | --- |
* | "Container" |
*
* @param {Subtitle_Extract_Container_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_container_label = /** @type {((inputs?: Subtitle_Extract_Container_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Container_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Récipient")
	if (locale === "de") return /** @type {LocalizedString} */ ("Container")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contenitore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контейнер")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recipiente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("容器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("容器")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पात्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Recipiente")
	return /** @type {LocalizedString} */ ("Container")
});